import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  TablePagination,
  createTheme,
  Dialog, DialogTitle, DialogActions, DialogContent,
  OutlinedInput,
  MenuItem,
  FormControl,
  InputLabel,
  CardMedia,
  Select,
  Chip,
  InputAdornment
} from '@material-ui/core';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import AlertScreen from 'src/components/Alert';
import moment from 'moment';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import { styled } from '@mui/system';
import { Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { getUser } from 'src/utils/Common';
import { base64Reader } from 'src/utils/storage/StrPhoto'
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import SaveIcon from '@material-ui/icons/Save';
import * as XLSX from 'xlsx';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
}));

const StyledCardMedia = styled(CardMedia)({
  height: '200px',
  backgroundSize: 'contain',
});


function Rule() {
  const classes = useStyles();
  const [Alert, setAlert] = useState(false);
  const [AlertType, setAlertType] = useState('');
  const [ResponseMessage, setResponseMessage] = useState('');
  const [Loading, setLoading] = useState(false);
  const [RuleData, setRuleData] = useState([]);
  const [RuleSearchData, setRuleSearchData] = useState([]);
  const [Popup, setPopup] = useState(false);
  const [Id, setId] = useState(0);
  const [Aktif, setAktif] = useState(1);
  const [Aciklama, setAciklama] = useState('');
  const [DetayAciklama, setDetayAciklama] = useState('');
  const [Tip, setTip] = useState('');
  const [search, setSearch] = React.useState('');

  const SessionUser = getUser();
  const setPopupOpen = (IdParam) => {
    setId(IdParam);
    var Data = RuleData.filter(x => x.KURAL_NO == IdParam);
    setAciklama(Data[0].ACIKLAMA);
    setDetayAciklama(Data[0].KURAL_ACIKLAMASI);
    if (Data[0].AKTIF === "Aktif") {
      setAktif(1);
    } else {
      setAktif(0);
    }
    setTip(Data[0].TIP);
    setPopup(true);
  }
  useEffect(() => {
    getRuleData(0);
  }, []);



  const handleSave = () => {

    setLoading(true);
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const requestData = {
      Id: Id,
      Aktif: Aktif,
      Aciklama: Aciklama,
      DetayAciklama: DetayAciklama,
      UserId: SessionUser?.UserId
    };



    axios.post('/SetApolloRule', requestData, config)
      .then(response => {
        var data = response.data;
        setResponseMessage(data.ErrorDescription);
        setAlert(true);
        setAlertType(data.ErrorCode === "1000" ? "error" : "success");
        setPopup(false);
        getRuleData(0);
      });
    setLoading(false);
  }


  const getRuleData = (IdParam) => {
    setLoading(true);
    axios.get(`/GetApolloRule/${IdParam}`)
      .then((response) => {
        const res = response.data;
        if (IdParam === 0) {
          setRuleData(res);
          setRuleSearchData(res);
        } else {
          setId(IdParam);

        }

      });
    setLoading(false);
  }


  const handleSearch = async (event) => {
    const newString = event?.target.value;
    setSearch(newString);
    if (newString) {
      const lowercasedNewString = newString.toLowerCase('tr-TR');
      const filteredData = RuleSearchData.filter(item => {
        const concatenatedStr = `${item.KURAL_NO ?? ''} ${item.ACIKLAMA ?? ''} ${item.TIP ?? ''} ${item.DURUM ?? ''} ${item.AKTIF ?? ''}`;
        const lowercasedConcatenatedStr = concatenatedStr.toLowerCase('tr-TR');
        return lowercasedConcatenatedStr.includes(lowercasedNewString);
      });
      setRuleData(filteredData);
    } else {
      setRuleData(RuleSearchData);
    }
  };

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('KURAL_NO');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedData = RuleData.slice().sort((a, b) => {
    if (orderBy) {
      if (order === 'asc') {
        return a[orderBy] < b[orderBy] ? -1 : 1;
      }
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
    return 0;
  });

  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);



  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Alert}
        autoHideDuration={10000}
        onClose={event => setAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <AlertScreen
          onClose={event => setAlert(false)}
          variant={AlertType}
          message={ResponseMessage}
        ></AlertScreen>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader
            title="Doğrulama Kuralları Yönetimi"
            action={
              <Grid container spacing={2} justifyContent="flex-end">
                <Grid item xs={12} sm={12} lg={12}>
                  <OutlinedInput
                    fullWidth
                    id="input-search-card-style1"
                    placeholder="Arama"
                    value={search}
                    onChange={handleSearch}
                    autoComplete="on"
                    size="small"
                    startAdornment={
                      <InputAdornment position="start">
                        <IconButton edge="start">
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
            }
          />
          <Divider />
          <CardContent>
            <TableContainer >
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'KURAL_NO'}
                        direction={orderBy === 'KURAL_NO' ? order : 'asc'}
                        onClick={() => handleRequestSort('KURAL_NO')}
                      >
                        Kural No
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'TIP'}
                        direction={orderBy === 'TIP' ? order : 'asc'}
                        onClick={() => handleRequestSort('TIP')}
                      >
                        Tip
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'DURUM'}
                        direction={orderBy === 'DURUM' ? order : 'asc'}
                        onClick={() => handleRequestSort('DURUM')}
                      >
                        Fiş Durum
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'AKTIF'}
                        direction={orderBy === 'AKTIF' ? order : 'asc'}
                        onClick={() => handleRequestSort('AKTIF')}
                      >
                        Aktif
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'ACIKLAMA'}
                        direction={orderBy === 'ACIKLAMA' ? order : 'asc'}
                        onClick={() => handleRequestSort('ACIKLAMA')}
                      >
                        Servis Açıklama
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'KURAL_ACIKLAMASI'}
                        direction={orderBy === 'KURAL_ACIKLAMASI' ? order : 'asc'}
                        onClick={() => handleRequestSort('KURAL_ACIKLAMASI')}
                      >
                        Detay Açıklama
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'EKLEME_TARIHI'}
                        direction={orderBy === 'EKLEME_TARIHI' ? order : 'asc'}
                        onClick={() => handleRequestSort('EKLEME_TARIHI')}
                      >
                        Tarih
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Düzenle</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    paginatedData.map((item) => (
                      <TableRow hover key={item.KURAL_NO}>
                        <TableCell>{item.KURAL_NO}</TableCell>
                        <TableCell>{item.TIP}</TableCell>
                        <TableCell>{item.DURUM}</TableCell>
                        <TableCell>
                          <Chip
                            label={item.AKTIF}
                            style={{ backgroundColor: item.AKTIF === 'Aktif' ? 'lightgreen' : 'lightcoral', color: 'white' }}
                          />
                        </TableCell>
                        <TableCell>
                          <Tooltip title={item.ACIKLAMA}
                            placement="left"
                            arrow>
                            {item.ACIKLAMA.substring(0, 70)}...
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Tooltip title={item.KURAL_ACIKLAMASI}
                            placement="left"
                            arrow>
                            {item.KURAL_ACIKLAMASI.substring(0, 70)}...
                          </Tooltip>
                        </TableCell>
                        <TableCell>{item.EKLEME_TARIHI}</TableCell>
                        <TableCell>
                          <IconButton
                            color='primary'
                            onClick={() => setPopupOpen(item.KURAL_NO)}
                            aria-label="settings">
                            <RemoveRedEyeIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={RuleData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={Popup}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Doğrulama Kuralları Yönetimi</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={3} sm={3} lg={3}>
              <TextField
                disabled
                fullWidth
                id="outlined-disabled"
                label="KuralNo"
                defaultValue={Id}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3} sm={3} lg={3}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-age-native-simple">Aktif</InputLabel>
                <Select
                  label="Aktif"
                  variant='outlined'
                  value={Aktif}
                  onChange={(e) => setAktif(e.target.value)}
                  fullWidth
                  size="small"
                >
                  <MenuItem key={0} value={0}>Pasif</MenuItem>
                  <MenuItem key={1} value={1}>Aktif</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} lg={6}>
              <TextField
                disabled
                fullWidth
                id="outlined-disabled"
                label="Tip"
                defaultValue={Tip}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                id="filled-multiline-flexible"
                label="Servise Görünen Açıklama"
                multiline
                fullWidth
                rows={3}
                variant="outlined"
                value={Aciklama}
                onChange={(e) => setAciklama(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                id="filled-multiline-flexible"
                label="Kural Detay Açıklama"
                multiline
                fullWidth
                rows={9}
                variant="outlined"
                value={DetayAciklama}
                onChange={(e) => setDetayAciklama(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { handleSave() }}
            endIcon={<SaveIcon />}
          >
            Kaydet
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopup(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}
export default Rule;
